import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginIntraEqHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginIntraEqTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginIntraEqTableMob: React.FC<IMarginIntraEqTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_ieq_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont EdelCode">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="EdelCode"
									onSort={props.sortProps.onSort}
									colName={marginIntraEqHeading.edelCode}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="EdelCode ib" dangerouslySetInnerHTML={{ __html: row.EdelCode }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont NSESymbol">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="NSESymbol"
									onSort={props.sortProps.onSort}
									colName={marginIntraEqHeading.nseSymbol}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ISIN">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ISIN"
									onSort={props.sortProps.onSort}
									colName={marginIntraEqHeading.isin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont IntradayMargin">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="IntradayMargin"
									onSort={props.sortProps.onSort}
									colName={marginIntraEqHeading.intradayMargin}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="NSESymbol ib">{row.NSESymbol}</span>
							</div>
							<div className="td">
								<span className="ISIN ib">{row.ISIN}</span>
							</div>
							<div className="td">
								<span className="IntradayMargin ib">{toINR(row.IntradayMargin)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginIntraEqTableMob;
